export const getTitle = ({
  levels,
  score,
}: {
  levels: {
    [score: number]: {
      title: string;
      color: string;
    };
  };
  score: number;
}) => {
  const levelKeys = Object.keys(levels).map(Number);

  let currentLevelTitle = '';

  for (let i = 0; i < levelKeys.length; i++) {
    if (score <= levelKeys[i]) {
      currentLevelTitle = levels[levelKeys[i]].title;
      break;
    }
  }

  return currentLevelTitle;
};
